// SPDX-License-Identifier: AGPL-3.0-or-later
type MediaDeviceCacheKind = 'audio' | 'video';
interface CachedDeviceEntry {
	devices: Array<MediaDeviceInfo>;
	fetchedAt: number;
}
type DeviceFetcher = () => Promise<Array<MediaDeviceInfo>>;
class MediaDeviceCache {
	private cache = new Map<MediaDeviceCacheKind, CachedDeviceEntry>();
	async getDevices(type: MediaDeviceCacheKind, fetchDevices: DeviceFetcher): Promise<CachedDeviceEntry> {
		const cached = this.cache.get(type);
		if (cached) {
			return cached;
		}
		const devices = await fetchDevices();
		const entry = {devices, fetchedAt: Date.now()};
		this.cache.set(type, entry);
		return entry;
	}
	invalidate(type: MediaDeviceCacheKind): void {
		this.cache.delete(type);
	}
	invalidateAll(): void {
		this.cache.clear();
	}
	startDeviceChangeListener(): () => void {
		return () => {};
	}
}
export const mediaDeviceCache = new MediaDeviceCache();
